import React, { useContext, useEffect } from 'react';
import LocaleContext from 'locales';
import { Route } from 'react-router-dom';
import { getCurrentConfig } from 'services/mgmt';

const RouteWithLayout = (props) => {
  const {
    layout: Layout,
    component: Component,
    name,
    menuId,
    access,
    componentProps,
    config,
    ...rest
  } = props;

  const { locale } = useContext(LocaleContext);

  if (access) {
    // #184958 메뉴 제어와 관련된 기능 목록으로 {configs의 키: menus.key}로 정의한다.
    const featureMenus = {
      approval: ['approval', 'request'], // approval 기능이 비활성화되면 approval과 request 메뉴 모두 비활성화
    };

    /**
     * #184958 비활성된 기능 메뉴 목록
     */
    useEffect(() => {
      getCurrentConfig()
        .then((configs) => {
          const disabledFeatureMenus = Object.keys(featureMenus).reduce((acc, cur) => {
            if (Object.prototype.hasOwnProperty.call(configs, cur)) {
              // 결재 타입이 사용자 일때만 포탈 좌측에 승인요청 메뉴 표시
              if (cur === 'approval') {
                // 사용자 결재 : 0, 관리자 승인 : 1
                if (configs.approval.approvalLineOption.type === 1) {
                  return [...acc, 'approval'];
                }
                return acc;
              }
              const menusToDisable = Array.isArray(featureMenus[cur])
                ? featureMenus[cur]
                : [featureMenus[cur]];
              return [...acc, ...menusToDisable];
            }
            const menusToDisable = Array.isArray(featureMenus[cur])
              ? featureMenus[cur]
              : [featureMenus[cur]];
            return [...acc, ...menusToDisable];
          }, []);
          const isDisabled = disabledFeatureMenus.filter((el) => access.includes(el)).length !== 0;
          if (isDisabled) {
            window.location = '/portal/error';
          }
        })
        .catch((error) => console.error(error));
    }, []);
  }

  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={(matchProps) => (
        <Layout currentPage={locale.resource[name]} menuId={menuId} config={config}>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Component {...matchProps} currentPage={name} menuId={menuId} {...componentProps} />
        </Layout>
      )}
    />
  );
};

export default RouteWithLayout;
